export default "__VITE_ASSET__7943d753__"